const WeatherServiceFactory = ({ HTTPBase }) => {
    return {
        getWeather: (weatherParams) => {
            const serializedParams = Object.entries(weatherParams)
                .map((pair) => pair.map(encodeURIComponent).join('='))
                .join('&');
            return HTTPBase.get(`/weather/forecast?${serializedParams}`).then((res) => res.data[0]);
        },
    };
};
export default WeatherServiceFactory;
//# sourceMappingURL=weather.api.js.map